export default class Top {
    constructor() {
        this.init();
    }

    init() {
        if ($('body').hasClass('ready')) {
            this.start();
            this.intro();
        }
        this.randomBag(); //初期バッグ
    }


    randomBag(){
        const rn = Math.floor(Math.random()*11)+1;
        const classname = 'bag'+rn;
        $('.stage__bag').addClass(classname);
    }


    openCurtain() {
        $('.stage__curtain_right,.stage__curtain_left').removeClass('close');
    }

    start() {
        let that = this;
        const tl = new TimelineMax();
        tl.set('.stage__curtain_right,.stage__curtain_left', {x: 0});
        tl.set('.stage__spotlight', {opacity: 0});
        tl.set('.stage__bag', {y: -800, rotation: '-720deg'});

        $('.top__start').on('click', function () {
            document.body.setAttribute("data-status", "game");

            tl.to('.top__logo', 1, {y: -200, opacity: 0, ease: Power3.easeInOut}, 0.1);
            tl.to('.top', 1, {opacity: 0, display: 'none'}, 0.1);
            tl.call(that.openCurtain, null, null, 1);
            tl.to('.stage__curtain_left', 1, {x: -270, ease: Power1.easeOut}, 1);
            tl.to('.stage__curtain_right', 1, {x: 270, ease: Power1.easeOut}, 1);
            tl.to('.stage__dark', 3, {opacity: 0}, 1.5);
            tl.to('.stage__spotlight', 0.1, {opacity: 1}, 2);
            tl.to('.stage__bag', 1, {y: 0, rotation: 0, scale: 1, ease: Back.easeOut}, 2);
            tl.to('.pullbtn,.shoulder_logo,.backbtn', 0.8, {opacity: 1, display: 'block'}, 2);
            tl.fromTo('.pullbtn__txt',0.5,{y:5},{y:-5,yoyo:true,repeat:-1},2.5);
        });
    }


    intro(){
        const tl = new TimelineMax();
        tl.set('.top__logo', {opacity:0,x:1000});
        tl.set('.top__start', {opacity:0,scale:1.5});
        tl.set('.top__backlight', {opacity:0});

        tl.to('.loader',1,{opacity:0,display:'none'},1);
        tl.to('.top__logo',1,{opacity:1,x:0,ease:Power2.easeOut},2);
        tl.to('.top__backlight',0.8,{opacity:1},2);
        tl.to('.top__start',0.5,{opacity:1,scale:1,ease:Back.easeOut.config(1.5)},3);
        tl.fromTo(
            ".top__start",
            0.8,
            { y: 5 },
            { y: -5, yoyo: true, repeat: -1 },
            3.5
        );
    }

}